export default {
    // 语言
    language: {
        name: 'English'
    },
    public:{
        email:'inquiry@governance-solutions.com'
    }
    
}